<article class="course-topic flex-container container">
  <section class="course-topic-content">
    <h2 *ngIf="!basic; else basicHeader">{{ courseIntro.title }}</h2>
    <ng-template #basicHeader>
      <h1>{{ courseIntro.title }}</h1>
    </ng-template>
    <p>{{ courseIntro.content }}</p>
    <span>Διάρκεια: {{ courseIntro.duration }} ώρες</span>
    <span>Μαθήματα: {{ courseIntro.lessons.join(", ") }}</span>
    <button *ngIf="courseIntro.path !== undefined" class="primary-btn"  aria-label="Read more">
      <a routerLink="/junior-front-end-developer/{{courseIntro.path}}" (click)="goTop()">Περισσότερα</a>
    </button>
  </section>
  <section class="course-topic-images"> 
    <picture *ngFor="let image of courseIntro.pngImages; let i = index">
      <source *ngIf="courseIntro.webpImages" type="image/webp" [srcset]="courseIntro.webpImages[i]">
      <img [src]="courseIntro.pngImages[i]" alt="{{ courseIntro.lessons[i] }} logo" />
    </picture>
  </section>
</article>
